<template>
   <form @submit.prevent="" novalidate ref="form">
 
    <OverlayLoading :isLoading="loading" />
    <div class="snippet general-event-config-snippet">
    
      <div class="form-group row mb-4">
        <div class="col-lg-6">
          <label>Question*</label>
          <div class="kt-input-icon">
            <input type="text" class="form-control" name="question" maxlength="200" :value="item.question" @input="updateQuestion" />
            <!-- <ValidationMessages :element="v$.item.question" /> -->
          </div>
        </div>
        <div class="col-lg-6">
          <label>Answer*</label>
          <!-- <v-select name="category" class="" placeholder="Select Category" label="label" @option:selected="updateCategory" :options="categoryEnum" :modelValue="sponsor.category" /> -->
          <input type="text" class="form-control" name="answer" maxlength="200"  :value="item.answer" @input="updateAnswer" />
        </div>
      </div>
      
      <div class="form-group row">
        <div class="offset-md-10 col-md-2">
          <div class="setting_wrapper">
            <button type="button" class="btn btn-primary" @click="submitForm">Update</button>
            &nbsp;<button type="button" class="btn btn-secondary" @click="cancelEdit">Cancel</button>
          </div>
        </div>
      </div>
    </div>
    <FlashMessage group="faq_edit"/>
  </form>
</template>

<script>
import {mapGetters, mapActions} from 'vuex'
import ObjectID from 'bson-objectid';
import _ from 'lodash';
import { gettingErrorMessage } from "@/services/GetValidationMessage";
// import ValidationMessages from "@/components/Commons/Validations/ValidationMessages";
import {
  useVuelidate
} from '@vuelidate/core'
import {
  required,
  email,
} from '@vuelidate/validators'

export default {
  name: "TagsEdit",
  // components: {       
  //       ValidationMessages
  //   },
  data() {
    return {
      moduleId: ObjectID(),
      selectedLanguage: null,
      languages: [],
    }
  },
  setup() {
        return {
            v$: useVuelidate()
        }
    },

    validations() {
        return {
            item: {
               
                title: {
                    required,
                }
            }
        };
    },
  props: {
   tag_id: String
  },
  computed: {
   // ...mapGetters("BlogsSingle", {event: "item"}),
    ...mapGetters("FaqSingle", [
      'item',
      'loading'
      // categoryEnum: "categoryEnum",
      ])
  },
  
  mounted() {
   // this.fetchEvent(this.$route.params.event_id)

   // this.fetchBlog(this.tag_id);
  },
  beforeUnmount() {
    this.resetState();
    delete this.$flashMessage.groups.faq_edit;
    },
  methods: {
    // ...mapActions('EventsSingle', {
    //   fetchEvent: 'fetchData',
    // }),
    ...mapActions('FaqSingle', {
      // fetchBlog: "fetchData",      
      setQuestion: "setQuestion",
      setAnswer: "setAnswer",     
      updateData: "updateData",
      resetState: "resetState",

    }),
    ...mapActions('FaqIndex', {
      fetchAllSponsors: "fetchData",
      setEditId: "setEditId",
    }),
    
    updateQuestion(e) {
      this.setQuestion(e.target.value)
    },
    updateAnswer(e) {
      this.setAnswer(e.target.value);
    },
    
    async submitForm(e) {
      e.preventDefault();
      this.updateData()
          .then(async () => {

            
            this.$flashMessage.show({
              group : 'faq',
              type  : 'success',
              title : 'Success',
              time  :1200,
              html  : "<ul><li>FAQ has been updated successfully.</li></ul>",
            });
            this.fetchAllSponsors(this.$route.params.event_id);
            this.resetState();
           
           
                
          })
          .catch((error) => {
                    console.log("errorerrorerror",error);
                    let html = gettingErrorMessage(error);
                    console.log("=====>",html);
                    //if (error.response.data.error) {
                        this.$flashMessage.show({
                            group: 'faq_edit',
                            type: 'error',
                            title: 'Failed',
                            text: html || 'Something went wrong',
                            html: html
                        });
                   // }
                })
    },

   
    cancelEdit() {
      this.resetState();
      this.setEditId(null);
    }
  }
}
</script>

<style scoped lang="scss">
.form-btn {
  color: #201e1eba;
  padding: 9px;
  margin-left: 5px;
  background: #c0cdd345;
  border-radius: 4px;
  border: 1px solid #80808054;

  &.save-btn {
    background: rgba(210, 206, 201, 0.27);
  }
}
</style>